<template>
  <div
    class="modal fade colored-header colored-header-primary"
    id="mod-add"
    role="dialog"
  >
    <div
      class="modal-dialog p-0 m-0 fixed top-0 right-0 flex justify-end items-end"
    >
      <div
        class="modal-content min-h-screen rounded-none bg-[#f8f8f8] p-[40px]"
      >
        <div
          class="modal-header modal-header-colored flex items-start justify-between p-0 m-0"
        >
          <h4
            class="font-semibold text-[20px] leading-[24px capitalize text-[#353535] pb-[16px]"
          >
            Invite new Business users
          </h4>
          <button
            class="text-2xl text-[#353535]"
            type="button"
            data-dismiss="modal"
            aria-hidden="true"
            @click="reset"
          >
            <span class="mdi mdi-close"></span>
          </button>
        </div>
        <div class="modal-body p-0 m-0">
          <div>
            <label
              class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
              >Email address</label
            >
            <div>
              <input
                :class="[{ 'is-invalid': $v.invitedUser.emailAddress.$error }]"
                type="email"
                placeholder="Email address of user"
                autocomplete="off"
                v-model.trim="$v.invitedUser.emailAddress.$model"
                class="bg-[#fcfcfd] border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.invitedUser.emailAddress.required"
              >
                Field is required.
              </div>
              <div
                class="invalid-feedback"
                v-if="!$v.invitedUser.emailAddress.email"
              >
                Email is invalid.
              </div>
            </div>
          </div>
          <div class="py-[16px]">
            <label
              class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
              >Role</label
            >
            <div class="">
              <select
                :class="[{ 'is-invalid': $v.invitedUser.role.$error }]"
                placeholder="Select an option"
                v-model="invitedUser.role"
                class="border border-[#D0D5DD] px-[14px] py-[12px] rounded-[8px] w-full text-[#96A0B5] outline-none custom-select custom-select-lg"
              >
                <option v-for="r in roles" :key="r.id" :value="r.text">
                  {{ r.text }}
                </option>
              </select>
              <div
                class="invalid-feedback"
                v-if="!$v.invitedUser.role.required"
              >
                Field is required.
              </div>
            </div>
          </div>
          <div class="pb-[16px]">
            <label
              class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
              >Staff Id</label
            >
            <div>
              <input
                class="bg-[#fcfcfd] border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full text-[14px]"
                type="text"
                placeholder="Staff Id of user"
                v-model="invitedUser.staffId"
              />
            </div>
          </div>
          <div class="pb-[16px]" v-if="invitedUser.role == 'Sales'">
            <label
              class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
              >Sales Access Id</label
            >
            <div>
              <input
                :class="[{ 'is-invalid': $v.invitedUser.salesAccessId.$error }]"
                type="text"
                placeholder="Sales Access Id of user"
                v-model.trim="$v.invitedUser.salesAccessId.$model"
                class="bg-[#fcfcfd] border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full"
              />
              <div
                class="invalid-feedback"
                v-if="
                  invitedUser.role === 'Sales' &&
                    !$v.invitedUser.salesAccessId.required
                "
              >
                Field is required.
              </div>
            </div>
          </div>
          <div class="pb-[16px]" v-if="user.type != 'Manufacturer'">
            <label
              class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
              >Branch</label
            >
            <div>
              <select
                :class="[{ 'is-invalid': $v.invitedUser.branch.$error }]"
                placeholder="Select an option"
                v-model.trim="$v.invitedUser.branch.$model"
                class="border border-[#D0D5DD] px-[14px] py-[12px] rounded-[8px] w-full text-[#96A0B5] outline-none custom-select custom-select-lg"
              >
                <option disabled value="">Select an option</option>
                <option v-for="br in branches" :key="br.id" :value="br.id">
                  {{ br.name }}
                </option>
              </select>
              <div
                class="invalid-feedback"
                v-if="!$v.invitedUser.branch.required"
              >
                Field is required.
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px]">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full disabled:cursor-not-allowed"
              type="button"
              @click="reset"
              data-dismiss="modal"
              :disabled="isInviting"
            >
              Cancel
            </button>
            <button
              :disabled="isInviting"
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full disabled:cursor-not-allowed"
              type="button"
              @click.prevent="invite"
            >
              {{ isInviting ? "Loading..." : "Invite User" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import { bus } from "../../main";
export default {
  name: "InviteUser",
  props: ["branches"],

  data() {
    return {
      isInviting: false,
      roles: [],
      invitedUser: {
        type: "email",
        emailAddress: "",
        role: "",
        branch: "",
        staffId: "",
        salesAccessId: "",
      },
    };
  },

  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
  },
  created() {
    this.getRoles();
    bus.$on("getroles", this.getRoles);
  },
  validations() {
    let invitedUser = {
      emailAddress: { required, email },
      role: { required },
    };

    if (this.user.type != "Manufacturer") {
      invitedUser = { ...invitedUser, branch: { required } };
    }

    if (this.invitedUser.role === "Sales") {
      return {
        invitedUser: { ...invitedUser, salesAccessId: { required } },
      };
    } else {
      return {
        invitedUser: invitedUser,
      };
    }
  },

  methods: {
    getRoles() {
      this.$http
        .get(
          "/roles/getRoleListNoPaging?parentId=" +
            this.user.parentId +
            "&roleType=" +
            this.user.type
        )
        .then(function(res) {
          this.roles = res.body;
        })
        .catch(function() {});
    },
    async invite() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isInviting = true;
        let data = {
          emailAddress: this.invitedUser.emailAddress,
          identifierType: this.invitedUser.type,
          userType: this.user.type,
          name: this.invitedUser.name,
          role: this.invitedUser.role,
          parentId: this.user.parentId,
          deliveryAddress: "N/A",
          branchId: this.invitedUser.branch,
          staffId: this.invitedUser.staffId,
          salesAccessId: this.invitedUser.salesAccessId,
          createdBy: this.user.displayName,
          isEnterpriseInvite: true,
          enterpriseName: this.user.displayName,
        };
        try {
          const response = await this.$http.post("/Users/invite", data);
          if (response.ok) {
            this.$toast.success("User invited successfully", {
              icon: true,
              rtl: false,
            });
            this.reset();
            this.$emit("onInviteComplete");
          }
        } catch (error) {}
        this.isInviting = false;
      }
    },

    reset() {
      this.invitedUser = {
        type: "email",
        emailAddress: "",
        role: "",
        branch: "",
        staffId: "",
        salesAccessId: "",
      };

      setTimeout(() => {
        this.$v.$reset();
      }, 0);
    },
  },
};
</script>

<style scoped>
input,
select {
  padding: 12px 14px !important;
  font-size: 14px !important;
  outline: none !important;
}
::placeholder {
  color: #96a0b5 !important;
  font-weight: 400 !important;
}
</style>
